import mutations from '@/store/modules/cart/mutations'

mutations.setLoyaltyThresholds = (state, thresholds) => {
  state.loyaltyThresholds = thresholds
}

mutations.setLoyaltyReward = (state, rewards) => {
  state.rewards = rewards
}

mutations.setLoyaltyCustomer = (state, customer) => {
  state.customer_loyalty = customer
}

mutations.setGiftCards = (state, giftcards) => {
  state.giftcards = giftcards
}

mutations.setActiveGiftCards = (state, giftcards) => {
  state.activeGiftcards = giftcards
}

export default {
  ...mutations
}
